import ProjectService from '_services/rest/modules/project';

export default {
  state: {
    status: null,
    project: null,
    fileList: null,
    projectList: null,
    detachedStatus: null,
    attachedStatus: null,
  },
  mutations: {
    setFile(state, response) {
      state.fileList = response;
    },
    setStatus(state, response) {
      state.status = response;
    },
    setProjectList(state, response) {
      state.projectList = response;
    },
    setAttachedStatus(state, response) {
      state.attachedStatus = response.map(status => {
        status.disabled = (status.finished_at);
        return status;
      });
    },
    setAttacherStausOrder(state, array) {
      state.attachedStatus = array.map((status, index) => {
        status.order = index;
        return status;
      });
    },
    setDetachedStatus(state, response) {
      state.detachedStatus = response;
    },
    setProject(state, response) {
      state.project = response;
      if (response.address.address) {
        const [street, number] = response.address.address.split(', ');
        state.project.address.street = street;
        state.project.address.number = number;
      } else {
        state.project.address.street = '';
        state.project.address.number = '';
      }
    },
  },
  actions: {
    getFile({ commit }, params) {
      return ProjectService.getFiles(params)
        .then(response => {
          commit('setFile', response);
        });
    },
    getProjectStatus({ commit }, params) {
      return ProjectService.getProjectStatus(params)
        .then(response => {
          commit('setStatus', response);
        });
    },
    getAttachedProjectStatus({ commit }, params) {
      return ProjectService.getAttachedProjectStatus(params)
        .then(response => {
          if (params.group && params.group === 'attached') {
            commit('setAttachedStatus', response);
            return response;
          }
          commit('setDetachedStatus', response);
          return response;
        });
    },
    getProjectList({ commit }, params) {
      return ProjectService.getList(params)
        .then(response => {
          commit('setProjectList', response);
        });
    },
    getProject({ commit }, params) {
      return ProjectService.getProjectById(params)
        .then(response => {
          commit('setProject', response);
        });
    },
    setAttachedStatus({ commit }, params) {
      commit('setAttachedStatus', params);
    },
    syncAttacherStaus({ commit }, { attachedStatus, projectId }) {
      commit('setAttacherStausOrder', attachedStatus);
      return ProjectService.syncStatus(attachedStatus, projectId);
    },
  },
};
